import { render, staticRenderFns } from "./WalletDaily.vue?vue&type=template&id=78aed5a0&scoped=true"
import script from "./WalletDaily.vue?vue&type=script&lang=js"
export * from "./WalletDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aed5a0",
  null
  
)

export default component.exports